import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import BannerArt from './BannerArt';
import Map from '../Map';
import { formatDeadline } from '../race';
import RacePk from './RacePk';
import styles from './index.css';

// const devQrcode = 'https://qrcode.ifeng.com/2026/10/26/8dbc1652a158f05fae1a567e9441c71e.png';
const onlineQrcode = 'https://qrcode.ifeng.com/2026/10/26/13caf7765019622a15e5550ec5ac8579.png';
const FLAG = 'https://x0.ifengimg.com/ucms/2026_43/6AE92D790D09C1FC9C7070BDBC20173173A16F51_size1_w40_h28.png';

const Poster = forwardRef(({ views }, ref) => {
    const [featured, ...rest] = views;
    const deadline = formatDeadline(featured.updateTime);

    return (
        <div className={styles.poster} ref={ref}>
            <div className={styles.postBanner}>
                <BannerArt isMarginTop={true} />
            </div>
            <div className={styles.card}>
                <div className={styles.head}>
                    <div className={styles.titleWrap}>
                        <img className={styles.flag} src={FLAG} alt="" crossOrigin="anonymous" />
                        <div className={styles.title}>{featured.title}</div>
                    </div>
                    {deadline ? <div className={styles.deadline}>{deadline}</div> : null}
                </div>
                <RacePk view={featured} variant="featured" />
                <div className={styles.height40} />
                <Map type={featured.type} data={featured.rows} interactive={false} />
                <div className={styles.pair}>
                    {rest.map(view => (
                        <div className={styles.mini} key={view.title}>
                            <div className={styles.miniTitle}>{view.title}</div>
                            <RacePk view={view} variant="compact" />
                        </div>
                    ))}
                </div>
            </div>
            <div className={styles.footer}>
                <img className={styles.logo} src="https://x0.ifengimg.com/ucms/2026_44/03484C3EF1437D77FBEDD751EF62CC0BD59A547B_size6_w266_h48.png" alt="凤凰新闻" />
                <div className={styles.qrBox}>
                    <div className={styles.qrText}>
                        扫描二维码
                        <br />
                        查看更多详情
                    </div>
                    <img className={styles.qr} src={onlineQrcode} alt="" crossOrigin="anonymous" />
                </div>
            </div>
        </div>
    );
});

Poster.propTypes = {
    views: PropTypes.array.isRequired,
};

export default Poster;
